import React from 'react'

const EstimatedPriceResultContent = () => (
  <>
    <section className="text-white bg-brand-fuchsia body-font">
      <div className="relative px-5 pb-4 mx-auto h-28">
        <div className="flex justify-center pt-5 md:pt-0 md:justify-start md:absolute left-8 top-5">
          <img src="/images/Logo.svg" alt="autoverkaufen.de" />
        </div>
      </div>
    </section>

    <section className="bg-gray-50">
      <div className="container px-5 py-5 mx-auto">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div className="col-span-2 overflow-hidden">
            <svg viewBox="0 0 258 98" xmlns="http://www.w3.org/2000/svg">
              <title>estimation-price</title>
              <g
                id="estimation-price"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                fontFamily="Verdana-Bold, Verdana"
                fontWeight="bold"
              >
                <text id="Das" fontSize="36" fill="#9800B3">
                  <tspan x="48.3564453" y="30">
                    Das
                  </tspan>
                </text>
                <text id="!" fontSize="46" fill="#9800B3">
                  <tspan x="238.746094" y="93">
                    !
                  </tspan>
                </text>
                <text id="Schaetzpreis" fontSize="36" fill="#9800B3">
                  <tspan x="5.51660156" y="92">
                    Schaetzpreis
                  </tspan>
                </text>
                <text id="ist-dein" fontSize="30" fill="#1F2937">
                  <tspan x="56.7514648" y="58">
                    ist dein
                  </tspan>
                </text>
              </g>
            </svg>
          </div>
          <div className="col-span-2">
            <div className="flex flex-col justify-center w-full h-full">
              <div className="mt-10 border-[12px] border-solid border-brand-lime rounded-3xl">
                <div className="flex flex-col w-full h-full">
                  <div className="flex items-center justify-between w-full px-4 pt-4 pb-0 mt-1">
                    <div className="w-full text-xl leading-7">
                      Dein Auto:
                      <strong className="font-bold">
                        {' '}
                        Audi A3, 2019, Sportback, 2.4i / 121 kW V6, Automatik, S-Line
                      </strong>
                    </div>
                  </div>
                  <div className="mx-4 my-0 font-bold leading-tight text-center text-blue-500 text-7xl">8.400 €</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10"></div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div className="col-span-2">
            <h3 className="text-gray-600 text-md md:text-left">
              Abo. Onsequi doluptur? Sinctiur sita non et es sinvelias nit ullaccus as dolo custion sequunt oditaquiat quia
              conem. Solupid ma sam, imendit voluptas nonsecu piento magnatium imagnat emquam, non con re dero es ipsaepudi
              comnimo luptur?
            </h3>
          </div>
          <div className="col-span-1 md:col-start-4">
            <a
              href="weitere-informationen.html"
              className="box-border block w-auto px-5 py-1 mx-auto mb-0 font-bold text-center text-white no-underline bg-blue-500 border-0 cursor-pointer md:h-auto h-14 hover:bg-blue-700 hover:text-white rounded-3xl"
              style={{ transition: 'color 200ms ease-in-out 0s' }}
            >
              <div className="flex items-center justify-center h-full">Jetzt Bestpreis ermitteln</div>
            </a>
          </div>
        </div>

        <div className="mb-16"></div>
      </div>
    </section>

    <section className="bg-gray-800">
      <div className="container px-5 py-24 mx-auto">
        <h3 className="text-3xl font-bold text-center text-white">Deine naechsten Schritte</h3>

        <div className="flex flex-wrap trigger-next-step-tile">
          <div className="w-full md:w-1/3">
            <div
              className="box-border px-8 py-6 m-4 bg-white border-2 border-l-2 border-gray-200 border-solid shadow-lg rounded-3xl border-opacity-60"
              data-ani="next-step-tile"
            >
              <div className="flex flex-col">
                <div className="absolute w-8 h-8 pt-1 font-bold text-center text-white rounded-full bg-brand-fuchsia">1</div>
                <div className="flex items-center justify-center px-8 mx-auto">
                  <img
                    src=" /images-optimized/Icon_Foto.gif"
                    alt="Icon Sicherheit"
                    className="overflow-hidden align-middle w-52"
                  />
                  <img
                    src=" /images-optimized/Icon_Foto_ani.gif"
                    alt="Icon Sicherheit"
                    className="hidden overflow-hidden align-middle w-52"
                  />
                </div>
              </div>
              <div className="py-4 text-sm leading-5 text-gray-700">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum voluptatum laborum iusto. Sed earum rem eos
                aliquid perferendis. Mollitia asperiores harum atque debitis laudantium qui rerum, ipsam dicta quae sit!
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/3">
            <div
              className="box-border px-8 py-6 m-4 bg-white border-2 border-l-2 border-gray-200 border-solid shadow-lg rounded-3xl border-opacity-60"
              data-ani="next-step-tile"
            >
              <div className="flex flex-col">
                <div className="absolute w-8 h-8 pt-1 font-bold text-center text-white rounded-full bg-brand-fuchsia">2</div>
                <div className="flex items-center justify-center px-8 mx-auto">
                  <img src="/images-optimized/Icon_Termin.gif" alt="Icon Sicherheit" className="overflow-hidden align-middle w-52" />
                  <img
                    src="/images-optimized/Icon_Termin_ani.gif"
                    alt="Icon Sicherheit"
                    className="hidden overflow-hidden align-middle w-52"
                  />
                </div>
              </div>
              <div className="py-4 text-sm leading-5 text-gray-700">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum voluptatum laborum iusto. Sed earum rem eos
                aliquid perferendis. Mollitia asperiores harum atque debitis laudantium qui rerum, ipsam dicta quae sit!
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/3">
            <div
              className="box-border px-8 py-6 m-4 bg-white border-2 border-l-2 border-gray-200 border-solid shadow-lg rounded-3xl border-opacity-60"
              data-ani="next-step-tile"
            >
              <div className="flex flex-col">
                <div className="absolute w-8 h-8 pt-1 font-bold text-center text-white rounded-full bg-brand-fuchsia">3</div>
                <div className="flex items-center justify-center px-8 mx-auto">
                  <img
                    src="/images-optimized/Icon_Pruefung.gif"
                    alt="Icon Sicherheit"
                    className="overflow-hidden align-middle w-52"
                  />
                  <img
                    src="/images-optimized/Icon_Pruefung_ani.gif"
                    alt="Icon Sicherheit"
                    className="hidden overflow-hidden align-middle w-52"
                  />
                </div>
              </div>
              <div className="py-4 text-sm leading-5 text-gray-700">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum voluptatum laborum iusto. Sed earum rem eos
                aliquid perferendis. Mollitia asperiores harum atque debitis laudantium qui rerum, ipsam dicta quae sit!
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 mt-16 md:grid-cols-4">
          <div className="col-span-3">
            <h3 className="text-2xl font-bold text-center text-white md:text-left">
              Der gesamte Service inklusive der Abmeldung ist fuer dich 100% kostenlos!
            </h3>
          </div>
          <div className="col-span-3 md:col-span-1">
            <a
              href="weitere-informationen.html"
              className="box-border block w-auto px-5 py-1 mx-auto mb-0 font-bold text-center text-white no-underline bg-blue-500 border-0 cursor-pointer md:h-auto h-14 hover:bg-blue-700 hover:text-white rounded-3xl"
              style={{ transition: 'color 200ms ease-in-out 0s' }}
            >
              <div className="flex items-center justify-center h-full ">Jetzt Bestpreis ermitteln</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  </>
)

export default EstimatedPriceResultContent
